import { Form, FormInfo } from "components/Forms";
import { RichText } from "components/RichTextWidget";
import { useTranslation } from "features/translations";
import { buildWidgetInstanceId } from "features/widgets";
import { WIDGETS_REGISTRY } from "features/widgets/widgets.config";
import {
  Action,
  Container,
  DetailsBlock,
  Heading4,
  Icon,
  ImageLite,
  ModalWrapper,
  PageLink,
  Paragraph,
} from "shared/components";
import { useToggle } from "shared/hooks";

import styles from "./Content035.module.scss";

export const Content035 = ({ payload }) => {
  const { t } = useTranslation();

  const { opened, onOpen, onClose } = useToggle();

  const title = payload?.title ?? "";
  const description = payload?.description ?? "";
  const image = payload?.image ?? {};
  const requestType = payload.button?.type ?? "form";
  const form = payload.button.form ?? {};
  const buttonText = payload.button?.buttonText ?? "";
  const link = payload.button?.link ?? "";

  const instanceId = buildWidgetInstanceId(
    "035",
    payload.id,
    WIDGETS_REGISTRY.CONTENT
  );

  const items = [
    { id: "date", label: t("date"), text: payload.startDate },
    { id: "time", label: t("time"), text: payload.duration },
    { id: "price", label: t("price"), text: payload.price },
    { id: "place", label: t("place"), text: payload.format },
  ];

  const timeDescription = payload.startDate;

  return (
    <div className={styles.wrapper}>
      <Container>
        <div className={styles.top}>
          <div className={styles.block}>
            <Heading4 className={styles.headline} color="dark">
              {title}
            </Heading4>
            <RichText value={description} className={styles.description} />
          </div>
          <div className={styles.block}>
            <DetailsBlock items={items} className={styles.course} />
            <div className={styles["button-wrap"]}>
              {requestType === "form" ? (
                <Action onClick={onOpen} className={styles.play}>
                  <Paragraph
                    className={styles.label}
                    appearance="bold"
                    color="light"
                    uppercase
                  >
                    {buttonText}
                  </Paragraph>
                  <span className={styles.arrow}>
                    <Icon className={styles.icon} name="arrow_right" />
                  </span>
                </Action>
              ) : (
                <PageLink className={styles.play} link={link}>
                  <Paragraph
                    className={styles.label}
                    appearance="bold"
                    color="light"
                    uppercase
                  >
                    {buttonText}
                  </Paragraph>
                  <span className={styles.arrow}>
                    <Icon className={styles.icon} name="arrow_right" />
                  </span>
                </PageLink>
              )}
            </div>

            {opened && (
              <ModalWrapper onCloseModal={onClose}>
                <Form
                  item={form}
                  metaData={{ type: "project", id: payload.id }}
                  info={<FormInfo title={title} date={timeDescription} />}
                  instanceId={instanceId}
                  onReset={onClose}
                />
              </ModalWrapper>
            )}
          </div>
        </div>
        <ImageLite image={image} className={styles.image} />
      </Container>
    </div>
  );
};

export default Content035;
